// extracted by mini-css-extract-plugin
export var blink = "styles-module--blink--yGETT";
export var c_option_card = "styles-module--c_option_card--dzT2p";
export var icon = "styles-module--icon--vgTas";
export var info = "styles-module--info--or2o-";
export var logo = "styles-module--logo--frS6k";
export var text = "styles-module--text--tA7d-";